import { defineStore } from "pinia";
import { ref } from "vue";

export const useProcedureApplicationStore = defineStore('procedureApplication', () => {
    const hideOfferPrice = ref(false);
    const isRequiredDocuments = ref(false);
    const isRequiredPositions = ref(true);
    const hideOfferCard = ref(false);
    const positionsSelectable = ref(false);
    const positionsSelectableCaption = ref('');

    function setHideOfferPrice(value) {
        hideOfferPrice.value = value;
    }

    function setRequiredDocuments(value) {
        isRequiredDocuments.value = value
    }

    function setRequiredPositions(value) {
        isRequiredPositions.value = value
    }

    function setHideOfferCard(value) {
        hideOfferCard.value = value
    }

    function setPositionsSelectable(value) {
        positionsSelectable.value = value
    }

    function setPositionsSelectableCaption(value) {
        positionsSelectableCaption.value = value
    }

    return {
        hideOfferPrice,
        isRequiredDocuments,
        isRequiredPositions,
        hideOfferCard,
        positionsSelectable,
        positionsSelectableCaption,
        setHideOfferPrice,
        setRequiredDocuments,
        setRequiredPositions,
        setHideOfferCard,
        setPositionsSelectable,
        setPositionsSelectableCaption
    }
});
